import { RootState } from '../types/store.type';
import { ENTITY_TYPE } from '../components/utils';

export const entitySuspensionsSelector = (state: RootState) =>
  state.orders.entitySuspensionInfo;

export const customerSuspensionsSelector = (state: RootState) =>
  state.orders.entitySuspensionInfo[ENTITY_TYPE.CUSTOMER.toUpperCase()]
    .suspensions;
